<section class="dashboard_content_sec">
  <div class="dashboard_bred_crumb">
    <ul>
      <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt=""></li>
      <li>My Pre owned Supplies</li>
    </ul>
  </div>
  <div class="my_supplies_listing">
    <!-- TABLE-LISTING -->
    <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column"
      fxLayoutAlign="start stretch" fxLayoutGap="15px">
      <div fxLayout="column" fxFlex="100" fxFlexFill>
        <!-- tables-section -->
        <section class="table_section">
          <!-- TABS -->
          <form [formGroup]="filterForm">
            <div class="custom-tabs">
              <mat-button-toggle-group formControlName="status" class="horizontal-toggle-buttons tabs-button-group"
                (change)="setStatus()">
                <mat-button-toggle value="DRAFT"
                  *ngIf="['SUPPLIER','PRACTICE','PROFESSIONAL'].includes(loginData.type)">
                  <span class="mat-button-content"> Draft </span>
                  <span class="total-count" *ngIf="statusWiseCount">{{statusWiseCount[0]}}</span>
                </mat-button-toggle>
               <!-- <mat-button-toggle value="PENDING_APPROVAL">
                  <span class="mat-button-content">Pending Approval</span>
                  <span class="total-count" *ngIf="statusWiseCount">{{statusWiseCount[1]}}</span>
                </mat-button-toggle>-->
                <mat-button-toggle value="APPROVED">
                  <span class="mat-button-content"> Approved </span>
                  <span class="total-count" *ngIf="statusWiseCount"> {{statusWiseCount[2]}} </span>
                </mat-button-toggle>
                <mat-button-toggle value="REJECTED">
                  <span class="mat-button-content"> Rejected </span>
                  <span class="total-count" *ngIf="statusWiseCount"> {{statusWiseCount[3]}} </span>
                </mat-button-toggle>
                <mat-button-toggle value="COMPLETED">
                  <span class="mat-button-content"> Completed </span>
                  <span class="total-count" *ngIf="statusWiseCount"> {{statusWiseCount[4]}} </span>
                </mat-button-toggle>
                <mat-button-toggle value="STOPPED">
                  <span class="mat-button-content"> Stopped </span>
                  <span class="total-count" *ngIf="statusWiseCount"> {{statusWiseCount[5]}} </span>
                </mat-button-toggle>
                <mat-button-toggle value="REMOVED">
                  <span class="mat-button-content"> Sold </span>
                  <span class="total-count" *ngIf="statusWiseCount"> {{statusWiseCount[6]}} </span>
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>
            <!-- ABSOLUTE-ADD-BUTTON -->
            <button type="button" mat-button class="table_fixed_add" [routerLink]='["../add"]'
              *ngIf="loginData && ['SUPPLIER','PRACTICE','PROFESSIONAL'].includes(loginData.type)">
              <i class="material-icons">add_circle_outline</i> Add Pre-owned supply
            </button>
            <div class="table_header">
              <div class="table_header_left w-50">
                <!-- SEARCH -->
                <div class="table_search_box">
                  <div class="custom-form-group">
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input type="search" matInput formControlName="search" placeholder="Search"
                          (keyup)="searchProductByName()">
                        <mat-icon matSuffix>
                          <img src="../../../../../../../assets/images/icons/search_grey.svg" alt="img"
                            class="search-icon">
                        </mat-icon>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table_header_right w-50">
                <button type="button" mat-button class="btn btn-sm send_approved_btn clear_filter_btn global-btn"  *ngIf="
                selection.selected.length &&
                loginData &&
                ['SUPPLIER','PRACTICE','PROFESSIONAL'].includes(loginData.type) &&
                ['DRAFT', 'REJECTED'].includes(status.value)"
                  (click)="sendForApprovalMultipleDialog()"> Send for Approval selected
                </button>
                <button type="button" mat-button class="btn btn-sm send_approved_btn clear_filter_btn" *ngIf="
                selection.selected.length &&
                loginData &&
                loginData.type === 'ADMIN' &&
                status.value ==='PENDING_APPROVAL'"
                  (click)="approveMultipleDialog()"> Approve selected
                </button>
                <button type="button" mat-button class="btn btn-sm bulk_filter_btn clear_filter_btn"
                  (click)="clearFilters()" *ngIf="filters.length">
                  Clear Filters
                </button>
                <button type="button" mat-button class="btn btn-sm bulk_filter_btn" (click)="filterToggle()">
                  <img src="../../../../../../../assets/images/icons/filter_slide.svg" alt="">
                  <span class="btn-content">Filter By :</span>
                  <img src="../../../../../../../assets/images/icons/filter_dropdown.svg" alt="">
                </button>
              </div>
            </div>
            <!-- MASTER-FILTER-OPEN-CLOSE-TOGGLE -->
            <section [@openCloseFilter]="openFilter ? true : false" class="openclose-filter-sec">
              <!-- FILTER-SECTION-ADD -->
              <section class="table-filter-sec" formArrayName="filters">
                <!-- first-filter-row -->
                <div class="table-filter-row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
                  fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="start center" fxLayoutGap="15px"
                  *ngFor="let single of filters.controls;let i = index" [formGroupName]="i">
                  <div class="filter-column" fxLayout="column" fxFlex="30" fxFlexFill>
                    <div class="custom-form-group">
                      <div class="custom-form-control">
                        <mat-form-field appearance="outline">
                          <mat-select placeholder="Select column" formControlName="column"
                            (selectionChange)="setFilter(single)">
                            <mat-option disabled value=""> Select Column </mat-option>
                            <mat-option *ngFor="let single of columnList" [value]="single">{{single.title}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="filter-column" fxLayout="column" fxFlex="30" fxFlexFill>
                    <div class="custom-form-group">
                      <div class="custom-form-control">
                        <mat-form-field appearance="outline">
                          <mat-select placeholder="Select column" formControlName="operator">
                            <mat-option disabled value=""> Select Operator </mat-option>
                            <mat-option *ngFor="let single of single.get('column')?.value?.operators"
                              [value]="single.operator">{{single.title}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="filter-column" fxLayout="column" fxFlex="30" fxFlexFill>
                    <div class="custom-form-group">
                      <div class="custom-form-control">
                        <ng-container *ngIf="single.get('column')?.value?.type === 'text'">
                          <mat-form-field appearance="outline">
                            <input matInput placeholder="Enter" formControlName="value" (keyup)="filterChange()">
                          </mat-form-field>
                        </ng-container>
                        <ng-container *ngIf="single.get('column')?.value?.type === 'select'">
                          <mat-form-field appearance="outline">
                            <mat-select formControlName="value" placeholder="Select Value"
                              (selectionChange)="filterChange()">
                              <mat-option
                                *ngFor="let single of filterObj[single.get('column')?.value?.tableName] | async"
                                [value]="single.id"> {{single.name}} </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                  <div class="filter_btn_column" fxLayout="column" fxFlex="10" fxFlexFill fxLayoutAlign="end end">
                    <!-- FILTER-ADD-BTN -->
                    <button type="button" mat-button class="btn btn-sm add_filter_btn global-btn" (click)="plusField()"
                      *ngIf="i === 0">
                      Add Filter
                    </button>
                    <!-- FILTER-Remove-BTN -->
                    <button type="button" mat-button class="remove_form_array_btn" (click)="minusField(i)"
                      *ngIf="i !== 0">
                      <i class="material-icons">close</i>
                    </button>
                  </div>
                </div>
              </section>
            </section>
          </form>
          <!-- table-data -->
          <!-- TABLE-LISTING -->
          <div class="custom-sticky-table" fxLayout="column" fxLayoutAlign="start stretch">
            <perfect-scrollbar>
              <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows
                (matSortChange)="sortData($event)">
                <!-- Checkbox Column -->
                <ng-container matColumnDef="select">
                  <th mat-header-cell *matHeaderCellDef [hidden]="!(
                  (loginData.type === 'ADMIN' && status.value === 'PENDING_APPROVAL') ||
                  (loginData.type === 'SUPPLIER' && ['REJECTED', 'DRAFT'].includes(status.value)))">
                    <mat-checkbox (change)="$event ? masterToggle() : null"
                      [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                    </mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let row"  [hidden]="
                  !((loginData.type === 'ADMIN' && status.value === 'PENDING_APPROVAL') ||
                  (loginData.type === 'SUPPLIER' && [ 'REJECTED', 'DRAFT'].includes(status.value)))">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                      [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                    </mat-checkbox>
                  </td>
                </ng-container>
                <!-- Name Column -->
                <ng-container matColumnDef="title">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="title"> Title </th>
                  <td mat-cell *matCellDef="let element"> {{element.title}} </td>
                </ng-container>
                <!-- supplier name Column -->
                <ng-container matColumnDef="supplier">
                  <th mat-header-cell *matHeaderCellDef
                    matTooltip="BO: Business Owner, DPR: Dental Practice Owner, DPF: Dental Professional"> BO/DPF/DPR
                  </th>
                  <td mat-cell *matCellDef="let element" data-label="BO/DPF/DPR">
                    {{element.dental_supplier?.business_name ?
                      element.dental_supplier?.business_name+'(BO)' :
                      ""
                    }}
                    {{element.dental_professional?.name ?
                      element.dental_professional?.name + '(DPF)'
                    :""}}
                    {{element.dental_practice?.name ?
                      element.dental_practice?.name + '(DPR)' :
                    "" }}
                  </td>
                </ng-container>
                <!-- Category name Column -->
                <ng-container matColumnDef="category">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="category"> Category </th>
                  <td mat-cell *matCellDef="let element" data-label="Category"> {{element?.supply_category?.name}} </td>
                </ng-container>
                <!-- Sub category name Column -->
                <ng-container matColumnDef="sub_category">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="sub_category">Sub Category </th>
                  <td mat-cell *matCellDef="let element" data-label="Sub Category"> {{element?.supply_sub_category?.name}} </td>
                </ng-container>
                <!-- Brand Column -->
                <ng-container matColumnDef="brand">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="brand">Brand</th>
                  <td mat-cell *matCellDef="let element" data-label="Brand"> {{element?.supply_brand?.name}} </td>
                </ng-container>
                <!-- Bid starts at Column -->
                <ng-container matColumnDef="bid_starts_at">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="bid_starts_at">Bid starts at </th>
                  <td mat-cell *matCellDef="let element" data-label="Bid starts at"> {{element?.bid_starts_at | date : "dd-MM-yyyy hh:mm a"}} </td>
                </ng-container>
                <!-- Bid ends at Column -->
                <ng-container matColumnDef="bid_ends_at">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="bid_ends_at">Bid ends at </th>
                  <td mat-cell *matCellDef="let element" data-label="Bid ends at "> {{element?.bid_ends_at | date: "dd-MM-yyyy hh:mm a" }} </td>
                </ng-container>
                <!-- Action Column -->
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef>
                    <span class="tab_head"> Action </span>
                  </th>
                  <td mat-cell *matCellDef="let element" data-label="action" (click)="$event.stopPropagation()"
                    (click)="$event.stopPropagation()" style="pointer-events:all;">
                    <button mat-icon-button [matMenuTriggerFor]="menu">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu" class="table-action-btn">
                      <button type="button" *ngIf="['APPROVED'].includes(status.value)" class="view" mat-menu-item
                        [routerLink]='["/dashboard/pre-owned-supplies/bids", element.id]'>
                        <img src="../../../../../../../assets/images/icons/action_icons/view.svg" alt="img">
                        <span> View Bids </span>
                      </button>
                      <button type="button" class="view" mat-menu-item [routerLink]='["/dashboard/pre-owned-supplies/view", element.id]'>
                        <img src="../../../../../assets/images/icons/action_icons/view.svg" alt="img">
                        <span> View </span>
                      </button>
                      <button type="button" class="view" mat-menu-item (click)="viewReason(element)"
                        *ngIf="status.value ==='REJECTED'">
                        <img src="../../../../../assets/images/icons/action_icons/view.svg" alt="img">
                        <span> View Reason </span>
                      </button>
                      <button type="button" class="edit" mat-menu-item [routerLink]='["/dashboard/pre-owned-supplies/edit", element.id]'
                      *ngIf="['SUPPLIER', 'PROFESSIONAL', 'PRACTICE'].includes(loginData.type)">
                        <img src="../../../../../assets/images/icons/action_icons/edit.svg" alt="img">
                        <span> Edit </span>
                      </button>
                      <!--<button type="button" class="delete" mat-menu-item (click)="deleteDialog(element)">
                        <img src="../../../../../assets/images/icons/action_icons/delete.svg" alt="img">
                        <span>Delete</span>
                      </button>-->
                      <button type="button" class="edit" mat-menu-item (click)="sendForApprovalDialog(element)"
                        *ngIf="['DRAFT', 'REJECTED'].includes(status.value)">
                        <img src="../../../../../assets/images/icons/action_icons/edit.svg" alt="img">
                        <span> Send for approval </span>
                      </button>
                      <button type="button" class="edit" mat-menu-item (click)="approveDialog(element)"
                        *ngIf="status.value === 'PENDING_APPROVAL' && loginData.type === 'ADMIN'">
                        <img src="../../../../../assets/images/icons/action_icons/edit.svg" alt="img">
                        <span> Approve </span>
                      </button>
                      <button type="button" class="delete" mat-menu-item (click)="rejectDialog(element)"
                        *ngIf="status.value === 'PENDING_APPROVAL' && loginData.type === 'ADMIN'">
                        <img src="../../../../../assets/images/icons/action_icons/edit.svg" alt="img">
                        <span> Reject </span>
                      </button>
                      <button type="button" class="edit" mat-menu-item (click)="activeDialog(element)"
                        *ngIf="['APPROVED'].includes(status.value) && element.product_status === 'INACTIVE' && loginData.type === 'SUPPLIER'">
                        <img src="../../../../../assets/images/icons/action_icons/edit.svg" alt="img">
                        <span> Active </span>
                      </button>
                      <button type="button" class="delete" mat-menu-item (click)="inactiveDialog(element)"
                        *ngIf="['APPROVED'].includes(status.value) && element.product_status === 'ACTIVE'  && loginData.type === 'SUPPLIER'">
                        <img src="../../../../../assets/images/icons/action_icons/inactive.svg" alt="img">
                        <span> Inactive </span>
                      </button>
                      <button type="button" *ngIf="['APPROVED'].includes(status.value) && ['SUPPLIER', 'PROFESSIONAL', 'PRACTICE'].includes(loginData.type)" class="delete" mat-menu-item
                        (click)="stopBidingDialog(element)">
                        <img src="../../../../../assets/images/icons/action_icons/edit.svg" alt="img">
                        <span> Stop biding </span>
                      </button>
                    </mat-menu>
                  </td>
                </ng-container>
                <ng-container matColumnDef="loading">
                  <th mat-footer-cell *matFooterCellDef colspan="8">
                    <div class="custom-loader custom_logo_loader">
                      <img src='../../../../../assets/images2/loader.gif' alt="img" loading="lazy" />
                    </div>
                  </th>
                </ng-container>
                <ng-container matColumnDef="noData">
                  <th mat-footer-cell *matFooterCellDef colspan="8"  class="no-data empty-img">
                      <img src='../../../../../../../assets/images/empty-imgs/no_products.svg' alt="img" loading="lazy" />
                      <h4 class="no_state_heading">No Pre-Owned Supplies</h4>
                  </th>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{ hide: dataSource != null }"></tr>
                <tr mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{hide: !( dataSource != null && dataSource.filteredData.length == 0)
            }"></tr>
              </table>
            </perfect-scrollbar>
          </div>
          <!-- TABLE-PAGINATOR -->
          <div fxLayout="column" fxLayout.lg="column" fxLayout.md="column" fxLayout.sm="column" fxLayout.xs="column"
            fxFlexFill fxLayoutGap="8px">
            <mat-paginator [length]="totalElements" [pageSize]="limit.value" (page)="changePage($event)">
            </mat-paginator>
          </div>
        </section>
      </div>
    </div>
  </div>
</section>
